import http from '@/plugins/axios_plugin';

class ServiceClientes {

    index (cliente_id) {
        return http.get('/api/clientes/config/listar?id=' + cliente_id)
    }

    carregarClientesFornecedor (fornecedor_id, rodada_id) {
        return http.get('/api/fornecedores/' + fornecedor_id + '/clientes/' + rodada_id);
    }

    carregarClientesPropriosFornecedor (fornecedor_id) {
        return http.get('/api/fornecedores/' + fornecedor_id + '/clientes');
    }

    carregarClientesRepresentante (representante_id) {
        return http.get('/api/representantes/' + representante_id + '/clientes')
    }

    carregarClientesAdministrador (administrador_id) {
        return http.get('/api/administradores/' + administrador_id + '/clientes');
    }

    carregarClientesMaster () {
        return http.get('/api/clientes/listar');
    }

    salvar (cliente) {
        return http.post('/api/clientes/salvar',cliente);
    }

    editar (cliente_id)
    {
        return http.get('/api/clientes/' + cliente_id + '/editar');
    }

    atualizar (cliente)
    {
        return http.post('api/clientes/' + cliente.id + '/atualizar', cliente);
    }

    excluir (cliente_id) {
        return http.delete('/api/clientes/' + cliente_id + '/excluir');
    }

    ativarDesativar (cliente_id) {
        return http.post('/api/clientes/' + cliente_id + '/ativardesativar');
    }

    listarLojas (cliente_id) {
        return http.get('/api/clientes/' + cliente_id + '/lojas/listar');
    }

    salvarLoja (cliente_id, loja) {
        return http.post('/api/clientes/' + cliente_id + '/lojas/salvar', loja);
    }

    atualizarLoja (cliente_id, loja) {
        return http.post('/api/clientes/' + cliente_id + '/lojas/' + loja.id+ '/atualizar', loja);
    }

    excluirLoja (cliente_id, loja) {
        return http.post('/api/clientes/' + cliente_id + '/lojas/' + loja.id+ '/excluir');
    }

    salvarConfig(cliente) {
        return http.post('/api/clientes/config/salvar', cliente)
    }

    representantes (cliente_id) {
        return http.get('/api/clientes/' + cliente_id + '/representantes')
    }

    representanteRelacionar (cliente_id, representante, acao) {
        let request = {
          'representante': representante,
          'acao': acao
        };
        return http.post('/api/clientes/' + cliente_id + '/representante/relacionar', request)
    }

    representanteDetalhar (representante_id) {
      return http.get('/api/representante/' + representante_id + '/detalhar')
    }

    desvincular (representante_id, cliente_id) {
        return http.post('/api/representantes/' + representante_id + '/clientes/' + cliente_id + '/desvincular')
    }

}

export default new ServiceClientes();
